import * as React from 'react';
import classNames from 'classnames';
import { SkinScreenWidthContainerProps } from '../../../SkinScreenWidthContainer';
import skinsStyle from './styles/skins.scss';

const LiftedTopScreen: React.FC<SkinScreenWidthContainerProps> = ({
  wrapperProps: {
    id,
    tagName = 'div',
    eventHandlers,
    className: propsClassName,
  },
  children,
  animation,
}) => {
  const SemanticElement = tagName as keyof JSX.IntrinsicElements;

  return (
    <SemanticElement
      id={id}
      className={classNames(
        skinsStyle.LiftedTopScreen,
        animation && skinsStyle[animation],
        propsClassName,
      )}
      {...eventHandlers}
    >
      <div className={skinsStyle.screenWidthBackground}></div>
      <div className={skinsStyle.centeredContent}>
        <div className={skinsStyle.centeredContentBg}>
          <div className={`${skinsStyle.shadow} ${skinsStyle.leftTop}`}></div>
          <div className={`${skinsStyle.shadow} ${skinsStyle.centerTop}`}></div>
          <div className={`${skinsStyle.shadow} ${skinsStyle.rightTop}`}></div>
          <div className={skinsStyle.bg}></div>
        </div>
        <div className={skinsStyle.inlineContent}>{children}</div>
      </div>
    </SemanticElement>
  );
};

export default LiftedTopScreen;
